import { render } from "./SideScrolling.vue?vue&type=template&id=3336579e"
import script from "./SideScrolling.vue?vue&type=script&lang=js"
export * from "./SideScrolling.vue?vue&type=script&lang=js"

import "./SideScrolling.vue?vue&type=style&index=0&id=3336579e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__